
import { supabase } from '@/integrations/supabase/client';
import { exampleAdsenseAds } from '@/data/exampleAds';

export const insertExampleAds = async () => {
  try {
    const { error } = await supabase
      .from('ads')
      .insert(exampleAdsenseAds);
    
    if (error) throw error;
    return { success: true };
  } catch (error) {
    console.error('Error inserting example ads:', error);
    return { success: false, error };
  }
};

export const getAdsByPosition = async (position: string) => {
  try {
    const { data, error } = await supabase
      .from('ads')
      .select('*')
      .eq('position', position)
      .eq('active', true);
    
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching ads:', error);
    return [];
  }
};
